import React from 'react'

// This is
// masterquotes.estputime
// V2 Shipment object shipment.dates.estimatedPickupTime

const PickupETA_Time = ({ render, value, onChange, inputFieldsReadOnly }) => {
    if (!render) return null
    return (
        <div className="form-group col col-lg-2">
            <label>Pickup Time (ETA):</label>
            <input
                className="form-control form-control-sm"
                name="dates.estimatedPickupTime"
                onChange={(event) => onChange(event)}
                type="time"
                value={value}
                disabled={inputFieldsReadOnly}
            />
        </div>
    )
}

export default PickupETA_Time
